<template>
  <div id="app" class="overlay relative min-h-screen flex items-center justify-center">

    <!-- Background Video -->
    <div class="absolute inset-0 z-0" v-if="showBackgroundVideo">
      <div class="video-container">
        <video
            v-if="isLandscape"
            class="video-landscape"
            autoplay
            muted
            loop
            playsinline>
          <source src="./video/trapen.webm" type="video/webm">
        </video>
        <video
            v-else
            class="video-portrait"
            autoplay
            muted
            loop
            playsinline>
          <source src="./video/prez.webm" type="video/webm">
        </video>
      </div>
      <div class="absolute inset-0 bg-black bg-opacity-25"></div>
    </div>

    <!-- Content Overlay -->
    <div class="relative z-10 bg-white bg-opacity-25 p-6 rounded-lg shadow-lg max-w-lg w-full mx-auto">
      <div class="flex justify-center mb-6">
        <img src="./assets/BDSM.png" alt="Jeux BDSM" class="h-16 w-auto" />
      </div>

      <!-- Loading Video -->
      <div v-if="showVideoLoader" class="overlay">
        <video autoplay muted loop playsinline  >
          <source src="./video/bdsm.webm" type="video/webm">
        </video>
        <div class="typing-overlay">
          <!-- Typing Text -->
          <div class="typing-text">
            <b>Bienvenue dans le monde BDSM...</b>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div v-else>
        <div v-if="loading" class="loader w-full h-12 bg-gray-200 rounded-full animate-pulse"></div>
        <div v-else class="mt-4 items-center justify-center">
          <div v-if="!choix.categorie1" class="al text-center text-gray-50 ">
            <blockquote class="text-2xl font-semibold italic text-center text-gray-50">
              Qui
              <span class="before:block before:absolute before:-inset-1 before:-skew-y-3 before:bg-pink-500 relative inline-block">
                <span class="relative text-white">veux</span>
              </span>
            ou
              <span class="before:block before:absolute before:-inset-1 before:-skew-y-3 before:bg-indigo-500 relative inline-block">
                <span class="relative text-white">osera  </span>
              </span>
              commencer ?
            </blockquote>
          </div>
          <div v-else>
            <h3 class="text-center text-lg text-gray-50"> <b>{{ choix.categorie1 }}</b></h3>
            <p class="text-center text-sm text-gray-50">Temps : <b>{{ timeLeft }}</b> secondes restantes</p>
            <div class="flex justify-center space-x-4 mt-4">
              <button @click="showForfeitPopup = true" class="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700">Perdu</button>
              <button @click="startTimer" class="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700">Démarrer le Timer</button>
            </div>
          </div>
        </div>

        <div class="mt-6 flex justify-center">
          <div class="flex space-x-4">
            <button @click="genererChoix('femme')" class="bg-pink-500 text-white px-4 py-2 rounded-lg hover:bg-pink-600">Choix Femme</button>
            <button @click="genererChoix('homme')" class="bg-indigo-500 text-white px-4 py-2 rounded-lg hover:bg-indigo-600">Choix Homme</button>
          </div>
        </div>

        <!-- Popup for Forfeit -->
        <div :class="{ 'popup-overlay': true, 'active': showForfeitPopup }" class="fixed inset-0 bg-black bg-opacity-50"></div>
        <div :class="{ 'popup': true, 'active': showForfeitPopup }" class="fixed inset-0 flex items-center justify-center">
          <div class="bg-white rounded-lg p-6 shadow-lg">
            <h2 class="text-xl font-bold text-center text-gray-800">Tu as perdu</h2>
            <p class="text-red-600 mt-2">{{ gage }}</p>
            <button @click="showForfeitPopup = false" class="mt-4 bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300">Fermer</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import sound from './audio/son.wav'
export default {
  data() {
    return {
      isLandscape: window.matchMedia("(orientation: landscape)").matches,
      showVideoLoader: true, // État du chargement de la vidéo
      progress: 0, // Progression du chargement
      showBackgroundVideo: false,
      showForfeitPopup: false,
      categoriesFemme: {
        categorie1: [
          "Fais une fellation avec des mouvements lents et sensuels.",
          "Masturbe ton partenaire en utilisant uniquement deux doigts",
          "Stimule doucement l'anus de ton partenaire avec ton doigt ou un jouet",
          "Lèche les tétons de ton partenaire en alternant pression légère et forte ",
          "Effectue un massage érotique sur l'intérieur des cuisses, en t'approchant sans toucher les zones intimes.",
          "Utilise tes lèvres pour embrasser chaque partie de son corps, sauf les zones intimes",
          "Stimule ton partenaire oralement tout en maintenant un contact visuel prolongé.",
          "Adopte une position provocante et fais semblant de te caresser sans le toucher directement.",
          "Glisse un doigt ou un jouet doucement autour de l'anus sans pénétration pour augmenter la tension.",
          "Utilise un plug anal sur ton partenaire tout en augmentant progressivement la pression.",
          "Fais une fellation avec un gode ou un jouet pour simuler la sensation.",
          "Porte un bâillon et stimule ton partenaire manuellement",
          "Menotte ton partenaire et provoque-le doucement avec un fouet ou une plume.",
          "Insère doucement un jouet anal et maintiens-le pendant le temps imparti",
          "Applique un jouet vibrant sur l’anus ou une autre zone sensible ",
          "Utilise une cravache légère pour alterner entre des tapes et des caresses ",
          "Appliquer un vibromasseur ou un autre jouet sur le soumis",
          "Stimule les zones érogènes de ton partenaire avec un fouet doux ou une spatule froide pour intensifier la pression.",
          "Embrasse et lèche les tétons de ton partenaire, en alternant entre douceur et mordillements légers.",
          "Offre une fellation ou un cunnilingus lent, en jouant avec des mouvements de langue variés.",
          "Dépose un crachat sensuel sur une partie intime avant de l’étaler doucement avec ta langue ou tes doigts.",
          "Masse les seins ou la poitrine de ton partenaire avec de l’huile chaude, en te concentrant sur les zones sensibles.",
          "Stimule le clitoris ou le pénis de ton partenaire avec des mouvements circulaires, en augmentant progressivement l’intensité.",
          "Utilise un lubrifiant pour une masturbation lente, tout en maintenant un contact visuel provocant.",
          "Stimule doucement l’anus de ton partenaire avec un doigt lubrifié ou un petit jouet anal.",
          "Applique un crachat sur la zone anale pour intensifier les sensations lors d’une caresse.",
          "Introduis un plug anal sur ton partenaire ou toi-même, en le gardant en place pendant 3 minutes.",
          "Masse les pieds de ton partenaire avec une huile parfumée, en t’attardant sur chaque orteil.",
          "Embrasse, lèche ou suce les orteils de ton partenaire de manière sensuelle.",
          "Utilise tes pieds pour caresser les jambes ou les zones intimes de ton partenaire.",
          "Assieds-toi sur les jambes de ton partenaire tout en stimulant ses zones intimes.",
          "Adopte une position vulnérable (à quatre pattes ou les jambes relevées) pour intensifier la tension.",
          "Utilise un bandeau pour les yeux et laisse ton partenaire explorer ton corps à son rythme.",
          "Masse les zones érogènes avec une plume ou un objet texturé pour jouer avec les contrastes.",
          "Reçois des tapes modérées sur les fesses ou la poitrine avec une cravache ou un paddle.",
          "Applique un bâillon (ball gag ou mors) pour ajouter une contrainte sensuelle.",
          "Attache les poignets ou les chevilles de ton partenaire avec des menottes pour limiter ses mouvements. Fais lui ce que tu veux",
          "Verse un peu de lubrifiant sur le corps de ton partenaire et utilise tes mains ou tes seins pour l’étaler.",
          "Provoque ton partenaire en simulant une pénétration avec un doigt ou un jouet sans aller jusqu’au bout.",
          "Reçois ou applique un massage intime, en variant les rythmes et les zones touchées.",
          "Masse les seins de ton partenaire tout en stimulant une autre zone (clitoris, pénis, ou anus).",
          "Utilise un jouet anal sur toi-même ou sur ton partenaire pendant une stimulation orale ou manuelle.",
          "Alterne entre des caresses douces et des crachats sensuels sur les zones intimes.",
          "Reste immobile pendant que ton partenaire utilise ses pieds pour stimuler tes zones érogènes.",
          "Laisse ton partenaire embrasser ou lécher tes pieds, tout en te caressant ailleurs.",
          "Insère un jouet ou un plug pendant que ton partenaire te masse les pieds avec intensité.",
          "Laisse ton partenaire jouer avec tes cheveux ou ton cou pendant une stimulation intime.",
          "Alterne entre des mouvements rapides et lents lors d’une masturbation mutuelle.",
          "Garde une position stimulante tout en recevant un massage du cou, des épaules, ou des fesses.",
          "Reste en position à genoux, tête baissée, pendant que ton partenaire explore ton corps avec des accessoires.",
          "Réalise une simulation de domination où tu obéis aux ordres de ton partenaire sans hésitation.",
          "Accepte un baiser intense où le sperme est échangé",
          "Applique du sperme préalablement conservé sur ses seins ou ses parties intimes, puis nettoie-le doucement avec ta bouche ou tes doigts.",
          "Verse du sperme sur son ventre ou son dos et masse-le doucement avant de le nettoyer.",
          "Dépose du sperme sur ses cuisses et lisse-le doucement avec tes mains ou une serviette.",
          "Applique du sperme sur ses pieds ou ses orteils et masse-le lentement avant de l’essuyer avec une serviette.",
          "Utilise du sperme sur ses bras ou ses épaules et nettoie-le doucement avec une éponge ou un tissu doux.",
          "Verse du sperme sur son ventre, explore ses zones intimes avec des caresses douces avant de le nettoyer.",
          "Applique une fine couche de sperme sur son visage, laissant-le s’écouler doucement avant de l’essuyer avec une serviette.",
          "Utilise du sperme sur ses genoux ou ses cuisses et essuie-le avec une lingette humide ou un tissu.",
          "Applique du sperme sur ses mains ou ses doigts et masse son corps ou ses zones sensibles, puis nettoie soigneusement.",
          "Dépose du sperme sur ses fesses et caresse-les doucement avant de le laver avec un gant de toilette.",
          "Applique du sperme préalablement conservé sur son ventre ou son torse, puis nettoie-le délicatement avec une serviette ou une éponge.",
          "Utilise du sperme sur ses épaules ou ses bras et masse-le lentement avant de le nettoyer avec une lingette.",
          "Dépose du sperme sur ses cuisses ou ses jambes, puis nettoie-le doucement avec une serviette humide.",
          "Applique du sperme sur ses pieds et explore-le avec des caresses avant de l’essuyer avec un tissu doux.",
          "Verse du sperme sur son dos ou son cou et caresse-le lentement avant de le nettoyer soigneusement.",
          "Applique une petite quantité de sperme sur ses mains ou ses doigts et explore ses zones érogènes avant de le laver.",
          "Dépose du sperme sur ses fesses et masser-les avant de l’essuyer avec une éponge humide.",
          "Utilise du sperme sur ses parties intimes et explore-les doucement, puis nettoie soigneusement.",
        ],
        categorie2: [
          ],
        categorie3: ["Balle bouche", "Menotte"],
        categorie4: ["60sec", "120sec"]
      },
      categoriesHomme: {
        categorie1: [
          "Fais une fellation avec des mouvements lents et sensuels.",
          "Masturbe ton partenaire en utilisant uniquement deux doigts",
          "Stimule doucement l'anus de ton partenaire avec ton doigt ou un jouet",
          "Lèche les tétons de ton partenaire en alternant pression légère et forte ",
          "Effectue un massage érotique sur l'intérieur des cuisses, en t'approchant sans toucher les zones intimes.",
          "Utilise tes lèvres pour embrasser chaque partie de son corps, sauf les zones intimes",
          "Stimule ton partenaire oralement tout en maintenant un contact visuel prolongé.",
          "Adopte une position provocante et fais semblant de te caresser sans le toucher directement.",
          "Glisse un doigt ou un jouet doucement autour de l'anus sans pénétration pour augmenter la tension.",
          "Utilise un plug anal sur ton partenaire tout en augmentant progressivement la pression.",
          "Fais une fellation avec un gode ou un jouet pour simuler la sensation.",
          "Porte un bâillon et stimule ton partenaire manuellement",
          "Menotte ton partenaire et provoque-le doucement avec un fouet ou une plume.",
          "Insère doucement un jouet anal et maintiens-le pendant le temps imparti",
          "Applique un jouet vibrant sur l’anus ou une autre zone sensible ",
          "Utilise une cravache légère pour alterner entre des tapes et des caresses ",
          "Appliquer un vibromasseur ou un autre jouet sur le soumis",
          "Stimule les zones érogènes de ton partenaire avec un fouet doux ou une spatule froide pour intensifier la pression.",
          "Embrasse et lèche les tétons de ton partenaire, en alternant entre douceur et mordillements légers.",
          "Offre une fellation ou un cunnilingus lent, en jouant avec des mouvements de langue variés.",
          "Dépose un crachat sensuel sur une partie intime avant de l’étaler doucement avec ta langue ou tes doigts.",
          "Masse les seins ou la poitrine de ton partenaire avec de l’huile chaude, en te concentrant sur les zones sensibles.",
          "Stimule le clitoris ou le pénis de ton partenaire avec des mouvements circulaires, en augmentant progressivement l’intensité.",
          "Utilise un lubrifiant pour une masturbation lente, tout en maintenant un contact visuel provocant.",
          "Stimule doucement l’anus de ton partenaire avec un doigt lubrifié ou un petit jouet anal.",
          "Applique un crachat sur la zone anale pour intensifier les sensations lors d’une caresse.",
          "Introduis un plug anal sur ton partenaire ou toi-même, en le gardant en place pendant 3 minutes.",
          "Masse les pieds de ton partenaire avec une huile parfumée, en t’attardant sur chaque orteil.",
          "Embrasse, lèche ou suce les orteils de ton partenaire de manière sensuelle.",
          "Utilise tes pieds pour caresser les jambes ou les zones intimes de ton partenaire.",
          "Assieds-toi sur les jambes de ton partenaire tout en stimulant ses zones intimes.",
          "Adopte une position vulnérable (à quatre pattes ou les jambes relevées) pour intensifier la tension.",
          "Utilise un bandeau pour les yeux et laisse ton partenaire explorer ton corps à son rythme.",
          "Masse les zones érogènes avec une plume ou un objet texturé pour jouer avec les contrastes.",
          "Reçois des tapes modérées sur les fesses ou la poitrine avec une cravache ou un paddle.",
          "Applique un bâillon (ball gag ou mors) pour ajouter une contrainte sensuelle.",
          "Attache les poignets ou les chevilles de ton partenaire avec des menottes pour limiter ses mouvements. Fais lui ce que tu veux",
          "Verse un peu de lubrifiant sur le corps de ton partenaire et utilise tes mains ou tes seins pour l’étaler.",
          "Provoque ton partenaire en simulant une pénétration avec un doigt ou un jouet sans aller jusqu’au bout.",
          "Reçois ou applique un massage intime, en variant les rythmes et les zones touchées.",
          "Masse les seins de ton partenaire tout en stimulant une autre zone (clitoris, pénis, ou anus).",
          "Utilise un jouet anal sur toi-même ou sur ton partenaire pendant une stimulation orale ou manuelle.",
          "Alterne entre des caresses douces et des crachats sensuels sur les zones intimes.",
          "Reste immobile pendant que ton partenaire utilise ses pieds pour stimuler tes zones érogènes.",
          "Laisse ton partenaire embrasser ou lécher tes pieds, tout en te caressant ailleurs.",
          "Insère un jouet ou un plug pendant que ton partenaire te masse les pieds avec intensité.",
          "Laisse ton partenaire jouer avec tes cheveux ou ton cou pendant une stimulation intime.",
          "Alterne entre des mouvements rapides et lents lors d’une masturbation mutuelle.",
          "Garde une position stimulante tout en recevant un massage du cou, des épaules, ou des fesses.",
          "Reste en position à genoux, tête baissée, pendant que ton partenaire explore ton corps avec des accessoires.",
          "Réalise une simulation de domination où tu obéis aux ordres de ton partenaire sans hésitation.",
          "Accepte un baiser intense où le sperme est échangé",
          "Applique du sperme préalablement conservé sur ses seins ou ses parties intimes, puis nettoie-le doucement avec ta bouche ou tes doigts.",
          "Verse du sperme sur son ventre ou son dos et masse-le doucement avant de le nettoyer.",
          "Dépose du sperme sur ses cuisses et lisse-le doucement avec tes mains ou une serviette.",
          "Applique du sperme sur ses pieds ou ses orteils et masse-le lentement avant de l’essuyer avec une serviette.",
          "Utilise du sperme sur ses bras ou ses épaules et nettoie-le doucement avec une éponge ou un tissu doux.",
          "Verse du sperme sur son ventre, explore ses zones intimes avec des caresses douces avant de le nettoyer.",
          "Applique une fine couche de sperme sur son visage, laissant-le s’écouler doucement avant de l’essuyer avec une serviette.",
          "Utilise du sperme sur ses genoux ou ses cuisses et essuie-le avec une lingette humide ou un tissu.",
          "Applique du sperme sur ses mains ou ses doigts et masse son corps ou ses zones sensibles, puis nettoie soigneusement.",
          "Dépose du sperme sur ses fesses et caresse-les doucement avant de le laver avec un gant de toilette.",
          "Applique du sperme préalablement conservé sur son ventre ou son torse, puis nettoie-le délicatement avec une serviette ou une éponge.",
          "Utilise du sperme sur ses épaules ou ses bras et masse-le lentement avant de le nettoyer avec une lingette.",
          "Dépose du sperme sur ses cuisses ou ses jambes, puis nettoie-le doucement avec une serviette humide.",
          "Applique du sperme sur ses pieds et explore-le avec des caresses avant de l’essuyer avec un tissu doux.",
          "Verse du sperme sur son dos ou son cou et caresse-le lentement avant de le nettoyer soigneusement.",
          "Applique une petite quantité de sperme sur ses mains ou ses doigts et explore ses zones érogènes avant de le laver.",
          "Dépose du sperme sur ses fesses et masser-les avant de l’essuyer avec une éponge humide.",
          "Utilise du sperme sur ses parties intimes et explore-les doucement, puis nettoie soigneusement.",
        ],
        categorie2: [],
        categorie3: ["Balle bouche", "Menotte"],
        categorie4: ["60sec", "120sec"]
      },
      choix: {
        categorie1: "",
        categorie2: "",
        categorie3: "",
        categorie4: ""
      },
      gagesHomme: ["Permets à ton partenaire de t'utiliser avec un gode-ceinture, en suivant son rythme et ses instructions.",
      "Reçois une pénétration avec un gode ceinture ou un jouet anal sous les ordres de ton partenaire.",
      "Effectue un pegging lent et sensuel, en variant les mouvements selon les désirs de ton partenaire.",
      "Laisse ton partenaire déposer du sperme sur ton corps et nettoie-le délicatement avec ta bouche ou tes doigts.",
      "Reçois un orgasme forcé avec un gode ou un vibromasseur, tout en exprimant ta gratitude pour chaque mouvement.",
      "Assume une position de soumission pendant qu'un gode-ceinture te pénètre lentement, sans pouvoir arrêter le processus.",
      "Exécute un nettoyage complet après un creampie, en utilisant ta bouche ou des serviettes selon les instructions.",
      "Permets à ton partenaire de t'utiliser avec un jouet anal pendant qu'il te stimule oralement ou manuellement.",
      "Accepte un cum kiss sur ton visage ou tes lèvres, et nettoie-le avec délicatesse selon les consignes de ton partenaire.",
      "Réalise une stimulation anale prolongée avec un gode-ceinture, tout en recevant un massage simultané de zones érogènes.",
        "Laisse ton partenaire te pénétrer vaginalement ou anally pendant que tu es attaché avec des menottes ou des cordes.",
      "Effectue une fellation lente et sensuelle sur ton partenaire sous bondage, respectant ses consignes tout au long.",
      "Reçois un creampie avec un partenaire attaché, et participe à son nettoyage selon ses instructions.",
      "Effectue une fellation profonde avec un partenaire en position soumise, tout en étant lié et contrôlé.",
      "Assume une position exposée et reçois une pénétration anale ou vaginale avec un gode ou jouet sous bondage.",
      "Effectue un 69 avec ton partenaire pendant qu'il est attaché et se concentre sur ses désirs.",
      "Laisse ton partenaire réaliser une pénétration pendant que tu es ligoté, avec une stimulation orale ou manuelle en parallèle.",
      "Reçois une pénétration profonde et contrôlée avec un vibromasseur sous bondage, en restant passif.",
      "Exécute une fellation intense sur ton partenaire lié avec des menottes, tout en respectant ses désirs de domination.",
      "Effectue un nettoyage après un creampie en utilisant une serviette ou ta bouche selon les instructions données."],
      gagesFemme: [
        "Assume une position de soumission pendant que tu reçois une pénétration avec un gode-ceinture ou un jouet anal.",
      "Laisse ton partenaire t'utiliser avec un gode ceinture, tout en suivant ses instructions strictes et en obéissant à chaque mouvement.",
      "Reçois un nettoyage post-cum avec ta bouche ou une serviette, selon les désirs de ton partenaire.",
      "Reçois une pénétration anal avec un jouet sous les ordres de ton partenaire, et permets-lui de réguler le rythme.",
      "Effectue un pegging lent et profond, tout en exprimant ta satisfaction avec des compliments ou des remerciements.",
      "Accepte une pénétration avec un gode ceinture tout en restant immobile et en suivant les ordres de ton partenaire.",
      "Laisse ton partenaire déposer du sperme sur ton corps ou ton visage et nettoie-le selon ses instructions strictes.",
      "Assume une position où tu es exposé(e) pendant que ton partenaire utilise un gode ou un jouet anal pour une stimulation prolongée.",
      "Effectue un nettoyage intensif après un creampie en utilisant ta bouche ou une lingette selon les instructions données.",
      "Reçois une série de pénétrations anales avec un gode ou jouet pendant qu'un vibromasseur est utilisé en parallèle pour une stimulation complète.",
        "Assume une position de bondage, et permets à ton partenaire de te pénétrer vaginalement ou anally sous ses instructions.",
        "Effectue une fellation lente et sensuelle pendant que ton partenaire est attaché avec des menottes ou une corde.",
        "Laisse ton partenaire déposer du sperme sur ton corps ou ton visage, puis nettoie-le délicatement avec ta bouche ou des serviettes.",
        "Reçois une pénétration avec un gode ceinture ou un jouet vaginal sous bondage, en suivant le rythme dicté par ton partenaire.",
        "Permets à ton partenaire de réaliser un creampie, puis nettoie-le avec tes mains ou une serviette selon ses désirs.",
        "Exécute un 69 avec ton partenaire, tout en respectant son rythme et ses directives.",
        "Attache-toi à un lit ou une chaise pendant que ton partenaire t’utilise pour une stimulation vaginale lente et profonde.",
        "Reçois une pénétration intense avec un gode ou un jouet sous bondage, tout en maintenant une position exposée.",
        "Exécute une fellation approfondie tout en te concentrant sur les zones érogènes de ton partenaire lié avec des menottes.",
        "Accepte une pénétration avec un vibromasseur pendant que ton partenaire t’utilise oralement ou manuellement.\n"],
      gage: "",
      loading: false,
      timer: null,
      timeLeft: 0,
    };
  },
  methods: {
    async genererChoix(categorie) {
      this.loading = true;
      await new Promise(resolve => setTimeout(resolve, 1000)); // Simule un temps d'attente
      if (!this.audio) {
        this.audio = new Audio(sound);
      }

      const categories =
          categorie === "femme" ? this.categoriesFemme : this.categoriesHomme;

      let choix1 = this.getRandomElement(categories.categorie1);
      let choix2 = this.getRandomElement(categories.categorie2);
      let choix3 = this.getRandomElement(categories.categorie3);
      let choix4 = this.getRandomElement(categories.categorie4);

      this.choix.categorie1 = choix1;
      this.choix.categorie2 = choix2;
      this.choix.categorie3 = choix3;
      this.choix.categorie4 = choix4;

      if (categorie === 'femme') {
        this.genererGageHomme();
      } else {
        this.genererGageFemme();
      }

      this.loading = false;
      this.initTimer();
    },
    genererGageFemme() {
      this.gage = this.gagesFemme[Math.floor(Math.random() * this.gagesFemme.length)];
    },
    genererGageHomme() {
      this.gage = this.gagesHomme[Math.floor(Math.random() * this.gagesHomme.length)];
    },
    getRandomElement(array) {
      return array[Math.floor(Math.random() * array.length)];
    },
    initTimer() {
      this.timeLeft = parseInt(this.choix.categorie4.replace('sec', ''));

      if (!isNaN(this.timeLeft) && this.timeLeft > 0) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    startTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      if (this.timeLeft > 0) {
        this.timer = setInterval(() => {
          this.timeLeft--;
          if (this.timeLeft <= 0) {
            clearInterval(this.timer);
            this.timer = null;
            this.playSound();
          }
        }, 1000);
      }
    },
    playSound() {
      if (this.audio) {
        this.audio.currentTime = 0;
        this.audio.play();
      }
    },
    updateOrientation() {
      this.isLandscape = window.matchMedia("(orientation: landscape)").matches;
    },
  },
  mounted() {
    setTimeout(() => {
      this.showVideoLoader = false;
      setTimeout(() => {
        this.showBackgroundVideo = true;
      }, 0);
    }, 11000);

    this.audio = new Audio(sound);
    window.addEventListener("resize", this.updateOrientation);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateOrientation);
  },
};
</script>

<style scoped>
.background-video {
  position: relative;
  height: 100vh;  /* Ajuste la hauteur de l'écran */
  width: 100vw;  /* Ajuste la largeur de l'écran */
}
.video-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}


video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;  /* Ajuste la vidéo pour couvrir toute la zone */
}
.container {
  text-align: center;
  font-family: Arial, sans-serif;
  margin: 150px auto; /* Centre verticalement et horizontalement */
  padding: 226px;
  max-width: 600px; /* Limite la largeur sur les écrans plus grands */
}

.card {
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  margin: 20px auto;
  padding: 20px;
  width: 300px;
  text-align: center;
}
.card-item {
  margin: 10px 0;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007BFF;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin: 20px auto;
}
.video-loader {
  position: relative; /* Fixe la position pour couvrir toute la fenêtre */
  top: 0;
  left: 0;
  width: 100vw; /* Largeur totale de la fenêtre */
  height: 100vh; /* Hauteur totale de la fenêtre */
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.9); /* Fond noir avec légère transparence */
  z-index: 5000; /* S'assure qu'il est au-dessus des autres éléments */
}
.video-background {
  width: 100%;
  height: auto;
}
.overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);  /* Semi-transparent noir */


  color: white;  /* Couleur du texte ou des éléments contenus dans l'overlay */
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.typing-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: inline-grid;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6); /* Semi-transparent noir */
  z-index: 2; /* S'assure que le texte est au-dessus de la vidéo */
}

/* Style pour le texte de chargement */
.typing-text {
  font-family: 'Courier New', Courier, monospace;
  font-size: 28px;
  font-weight: bold;
  color: white;
  white-space: nowrap; /* Empêche le texte de revenir à la ligne */
  border-right: 3px solid white; /* Curseur visible */
  max-width: 100%;
  overflow: hidden; /* Cache le texte non encore affiché */
  width: 0; /* Initialise à 0 pour l'animation */
  animation: typing 10s steps(30, end) forwards, blink-cursor 0.8s step-end infinite;
}

/* Animation typing */
@keyframes typing {
  from {
    width: 0; /* Commence sans largeur */
  }
  to {
    width: 100%; /* Dévoile tout le texte */
  }
}

/* Animation du curseur clignotant */
@keyframes blink-cursor {
  from, to {
    border-color: transparent; /* Cache le curseur */
  }
  50% {
    border-color: white; /* Montre le curseur */
  }
}

@media (max-width: 480px) {
  .container {
    margin: 100px auto; /* Réduit la marge sur mobile */
    padding: 0; /* Réduit l'espace interne */
    max-width: 90%; /* Adapte la largeur au viewport */

  }

  .card {
    width: 100%; /* Utilise toute la largeur sur mobile */
    font-size: 14px; /* Réduit la taille de police */
  }  .typing-text {
    width: 100%; /* Utilise toute la largeur sur mobile */
    font-size: 14px; /* Réduit la taille de police */
  }


  .forfeit-container {
    font-size: 14px; /* Réduit la taille de police des boutons */
    padding: 8px 16px
  }
  }

/* Styles spécifiques aux tablettes */
@media (max-width: 768px) and (min-width: 481px) {
  .container {
    margin: 120px auto; /* Ajuste la marge sur tablette */
    padding: 20px; /* Espace interne légèrement augmenté */
    max-width: 80%; /* Adapte la largeur */
  }

  .card {
    font-size: 16px; /* Taille de texte intermédiaire */
  }


  .forfeit-container {
    font-size: 16px;
    padding: 10px 20px;
  }
}

/* Styles pour les ordinateurs portables */
@media (min-width: 769px) {
  .container {
    margin: 150px auto; /* Ajuste la marge */
    max-width: 600px; /* Largeur par défaut pour laptop */
    padding: 120px; /* Espace interne suffisant */
  }

  .card {
    font-size: 18px; /* Texte plus grand pour laptop */
  }


  .forfeit-container {
    font-size: 18px;
    padding: 12px 24px;
  }
}

.forfeit-container {
  margin-top: 20px;
  text-align: center;
}

.forfeit-container button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.forfeit-container button:hover {
  background-color: #c0392b;
}

.forfeit-container p {
  margin-top: 10px;
  font-size: 18px;
  font-weight: bold;
  color: #e74c3c;
}

.popup {
  display: none; /* Cachée par défaut */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10000; /* Au-dessus des autres éléments */
  padding: 20px;
  border-radius: 10px;
}

.popup.active {
  display: block; /* Affiche la popup lorsqu'elle est active */
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent */
  display: none;
  z-index: 9999; /* Au-dessous de la popup */
}

.popup-overlay.active {
  display: block; /* Affiche l'overlay lorsqu'il est actif */
}
.button-group {
  display: flex;
  justify-content: center;
  gap: 10px; /* Espacement entre les boutons */
}

.button-group button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #ff9000;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.button-group button:hover {
  background-color: #0056b3;
}

</style>
